import { Formik } from 'formik';

import NameForm from './nameForm';
import { STEP, State } from './generateReportReducer';
import FiltersForm from './filtersForm';

import { nortadaLogger } from '../../logger';
import { BusinessError } from '../../business-error';
import { FiltersFormType, HandleGenerateReport } from '../interfaces';

interface Props<T> {
  state: State;
  handleGenerateReport: HandleGenerateReport<T>;
  handleOpenNextPage: () => void;
  isGenerating: boolean;
  filtersForm: FiltersFormType<T>;
  initialValues: T & { name: string };
}

const GenerateReport = ({
  state,
  handleGenerateReport,
  handleOpenNextPage,
  isGenerating,
  filtersForm,
  initialValues
}: Props<unknown>) => (
  <Formik
    validateOnMount
    validationSchema={state.validation}
    initialValues={initialValues}
    onSubmit={values => {
      handleGenerateReport(values);
    }}
  >
    {({ values, setFieldValue, errors, handleSubmit, isValid, touched, setTouched, handleBlur }) => {
      const handleChange = (field: string, value: unknown) => {
        setFieldValue(field, value);
      };

      const onOpenNextPage = () => {
        setTouched({ name: true });
        if (isValid) {
          handleOpenNextPage();
        }
      };

      const getPage = () => {
        switch (state.currentPage) {
          case STEP.NAME: {
            return (
              <NameForm
                handleChange={handleChange}
                handleBlur={() => {}}
                values={values}
                errors={errors}
                touched={touched}
                handleOpenNextPage={onOpenNextPage}
              />
            );
          }
          case STEP.FILTERS: {
            return (
              <FiltersForm
                filtersForm={filtersForm}
                reportGenerating={isGenerating}
                values={values}
                handleChange={handleChange}
                errors={errors}
                handleSubmit={handleSubmit}
                touched={touched}
                handleBlur={handleBlur}
              />
            );
          }
          case STEP.BUSINESS_ERROR: {
            return (
              <FiltersForm
                filtersForm={filtersForm}
                reportGenerating={isGenerating}
                values={values}
                handleChange={handleChange}
                errors={errors}
                handleSubmit={handleSubmit}
                touched={touched}
                handleBlur={handleBlur}
                generatedBusinessErrorSeverity={(state.payload?.error as BusinessError).severity}
                generatedBusinessError={(state.payload?.error as BusinessError).message}
              />
            );
          }
          default: {
            throw nortadaLogger.critical(`${state.currentPage} page is not supported`);
          }
        }
      };
      return getPage();
    }}
  </Formik>
);

export default GenerateReport;
